<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AddPlaylist />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AddPlaylist from "./components/AddPlaylist";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    AddPlaylist,
    // ProjectsTable,
  },
};
</script>
